export default __webpack_public_path__ + "static/media/flag-tokelau.c3600ded.svg";